// Copyright (C) 2019 TANNER AG

import React, { useContext } from "react";
import * as PropTypes from "prop-types"
import { withStyles, Grid } from "@material-ui/core"
import classnames from "classnames";
import { TranslationContext } from "../translation";
import { BusImage } from "../components/busimage";

const styles = {
	item: {
		transition: "all 0.3s",
		"& $active": {
			boxShadow: "0 0 5px 0 #e2e3e4",
			borderColor: "#e40045"
		},
		"& $itemInner:hover": {
			boxShadow: "0 0 5px 0 #e2e3e4",
			transition: "all 0.3s"
		}
	},
	active: {},
	disabled: {
		cursor: "default !important",
		pointerEvents: "none",
		touchAction: "none",
		opacity: 0.3
	},
	itemInner: {
		border: "3px solid transparent",
		paddingBottom: "17px",
		borderRadius: "6px",
		transition: "opacity 0.3s",
		boxSizing: "border-box",
		cursor: "pointer"
	},
	img: {
		"& > img": {
			width: "100%",
			height: "auto",
			borderRadius: "6px",
			border: "2px solid transparent",
		}
	},
	title: {
		fontFamily: "MANEurope, Arial, sans-serif",
		fontWeight: "bold",
		fontStretch: "condensed",
		fontSize: "22px",
		lineHeight: "30px",
		textAlign: "center",
		color: "#303c49",
		marginTop: "17px"
	},
	description: {
		fontFamily: "MANEurope, Arial, sans-serif",
		fontWeight: 300,
		fontStyle: "normal",
		fontSize: "15px",
		lineHeight: "22px",
		textAlign: "center",
		color: "#303c49"
	}
};

const BusItem = (props) => {
	const { classes, bus, onClick } = props;
	const { translate } = useContext(TranslationContext);

	return (
		<Grid item xs={3} classes={{ item: classes.item }} style={{ transformOrigin: '0 0 0' }}>
			<div
				onClick={onClick}
				className={classnames(
					classes.itemInner, {
						[classes.active]: props.active,
						[classes.disabled]: props.disable && !props.active
					})}
			>
				<div className={classes.img}>
					<BusImage
						fuel={bus.fuel}
						type={bus.type}
						name={bus.name}
					/>
				</div>
				<div>
					<div className={classes.title}>{bus.name}</div>
					<div className={classes.description}>
						{`${bus.doors} ${translate("common.doors")}`}, {bus.fuel}
					</div>
				</div>
			</div>
		</Grid>
	);
};

BusItem.propTypes = {
	bus: PropTypes.object,
	onClick: PropTypes.func,
	active: PropTypes.bool,
	disable: PropTypes.bool
};

export default withStyles(styles)(BusItem);



// WEBPACK FOOTER //
// ./src/tco/entry/busitem.js